import { render } from "./trendstatisticalList.vue?vue&type=template&id=1919c4e2&scoped=true"
import script from "./trendstatisticalList.vue?vue&type=script&lang=js"
export * from "./trendstatisticalList.vue?vue&type=script&lang=js"

import "./trendstatisticalList.vue?vue&type=style&index=0&id=1919c4e2&scoped=true&lang=css"
import "./trendstatisticalList.vue?vue&type=style&index=1&id=1919c4e2&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1919c4e2"]])

export default __exports__